import { render, staticRenderFns } from "./TipoValorList.vue?vue&type=template&id=a6a8b952"
import script from "./TipoValorList.vue?vue&type=script&lang=js"
export * from "./TipoValorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports